export default __webpack_public_path__ + "static/4-044074276affce94cad489f7ee9dd175.jpg";